'use client'

import {
  type PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { themes } from '~/styles/colors'

export const ThemeContext = createContext({})

export function ThemeProvider({
  children,
  name,
}: PropsWithChildren<{ name: string }>) {
  const [themeName, setTheme] = useState(name)
  const theme = useMemo(
    () => themes[themeName as keyof typeof themes],
    [themeName]
  )

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', themeName)
  }, [themeName])

  return <ThemeContext value={{ theme, setTheme }}>{children}</ThemeContext>
}

export function useTheme() {
  return useContext(ThemeContext)
}
